import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { FullPayoutsTable } from './FullPayoutsTable'

export default function ShopModulePayoutsPage() {
  const { t } = useTranslation('shop-modules-fullpayout')
  const { shopModuleId } = useParams<{ shopModuleId: string }>()

  return (
    <PageLayout>
      <PageHeader title={t('header.title')} description={t('header.description')} />
      <FullPayoutsTable shopModuleId={Number(shopModuleId)} />
    </PageLayout>
  )
}
